import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.createInvoice
)

export const selectIsCreateInvoiceModalOpen = createSelector(
    baseSelector,
    (state) => state.isCreateInvoiceModalOpen
)

export const selectOnCreate = createSelector(
    baseSelector,
    (state) => state.onCreate
)